/**
 * Retourne le détail de l’erreur.
 * @param {object} param0
 * @param {object} param0.error
 * @return {string}
 */
export default function apiGetErrorDetail({ error }) {
  return error?.body?.errors?.[0]?.detail;
}
